<template>
  <div class="contenedor">
    <section class="seccionInicial" id="seccionInicial">
      <div class="textos">
        <h1 class="animate__animated animate__backInDown">ALMOBY</h1>
        <p class="animate__animated animate__bounceInRight">
          Impulsá el crecimiento de tu empresa con tecnología que
          <span class="spanTexto">se adapta a vos.</span>
        </p>
      </div>
      <img class="compu animate__animated animate__rotateInDownRight" src="@/assets/images/compu.png" alt="" />
    </section>
    <section class="seccion comoTrabajamos" id="comoTrabajamos">
      <p class="p1">¿Querés entender cómo trabajamos, por qué somos distintos y cómo podemos ayudarte?</p>
      <p class="p2">En este video te lo contamos, ¡dale play y descubrilo!</p>
      <div class="video-container">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/xrorusHiEUQ" title="Cómo trabajamos"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen>
        </iframe>
      </div>
    </section>
    <section class="seccion tecnologia">
      <p class="p1 pTecno">¿Cuánto más vas a postergar lo que sabés que necesitás?
        Tu equipo lo va a agradecer. Tus resultados también. <br>
        <span class="spanTexto">Es hora de que la tecnología se adapte a vos.</span>
      </p>
      <div class="contenedorBoton">
        <a href="https://wa.me/5493774516910?text=Hola%20Almoby%2C%20vengo%20desde%20la%20web.%20Quisiera%20hacer%20una%20consulta."
          target="_blank" rel="noopener" aria-label="Escribir por WhatsApp" title="Escribir por WhatsApp">QUIERO AGENDAR
          UNA REUNIÓN</a>
      </div>
      <div class="sistAmedida">
        <div class="contenedorTextosSist animate__animated">
          <p class="pSist">SISTEMA</p>
          <p class="pSist pSistEsp">A MEDIDA</p>
        </div>
        <p class="pSistLarg">Estás a una decisión de dejar atrás el caos operativo y avanzar con un sistema que por fin
          se adapta a vos y
          a tu empresa.</p>
      </div>

      <div class="checklist">
        <p data-aos="zoom-in"><span class="check">✔</span> ¿Tu equipo sigue resolviendo con Excel, WhatsApp y memoria?
        </p>
        <p data-aos="zoom-in"><span class="check">✔</span> ¿Cada cambio que querés hacer es una batalla con tu sistema
          actual?</p>
        <p data-aos="zoom-in"><span class="check">✔</span> ¿El crecimiento trajo más desorden que resultados?</p>
        <p data-aos="zoom-in"><span class="check">✔</span> ¿Seguís anotando todo en un cuaderno… y después nadie lo
          encuentra?</p>
        <p data-aos="zoom-in"><span class="check">✔</span> ¿Sentís que estás forzando procesos en lugar de fluir?</p>
      </div>

      <div class="contenedorMarron">
        <p style="border-bottom: solid 3px #C13405;">Sabés que no podés seguir mucho tiempo más.</p>
        <p style="color: #C13405; width: 60%;">
          Tu sistema actual no está frenando solo tareas: está frenando decisiones, oportunidades y resultados.</p>
        <p style="color: #C13405; width: 60%;"><strong>
            Y lo peor: ya te acostumbraste al caos. Pero no tiene por qué ser así.</strong></p>

      </div>

      <p>esto es Lo que pasa cuando <span style="color: #B93205">la tecnología por fin se adapta a vos:</span></p>
      <div class="cuadriculaNaranja">
        <div class="rectanguloNaranja" data-aos="flip-right">
          <p class="rnP1">Escalás con orden,</p>
          <p class="rnP2">no con más caos.</p>
          <p class="rnP3">Te ayudamos a crecer sin sumar complejidad.</p>
        </div>
        <div class="rectanguloNaranja" data-aos="flip-up">
          <p class="rnP1">todo fluye,</p>
          <p class="rnP2">todo se conecta.</p>
          <p class="rnP3">Integraciones con lo que ya usás (ERP, APIs, CRMs, etc.)</p>
        </div>
        <div class="rectanguloNaranja" data-aos="flip-left">
          <p class="rnP1">tu lógica de negocio</p>
          <p class="rnP2">es la base del desarrollo.</p>
          <p class="rnP3">No te adaptás al sistema. El sistema se adapta a vos.</p>
        </div>
        <div class="rectanguloNaranja" data-aos="flip-down">
          <p class="rnP1">acompañamiento real,</p>
          <p class="rnP2">sin respuestas genéricas.</p>
          <p class="rnP3">Trabajamos codo a codo con vos. Desde el diagnóstico hasta después del lanzamiento.</p>
        </div>
      </div>
    </section>
    <section class="seccion sobreAlmoby" id="sobreNosotros" data-aos="zoom-in">
      <h2>SOBRE ALMOBY</h2>
      <p>Almoby nació como un proyecto familiar, impulsado por tres hermanos que compartían una idea clara: <strong> la
          tecnología tiene que adaptarse a las personas, y no al revés.</strong>
      </p>
      <p>
        Con los primeros clientes entendimos que el verdadero diferencial no estaba solo en lo que desarrollábamos,sino
        en cómo lo hacíamos: <strong>escuchando, acompañando, siendo parte del proceso desde el inicio.</strong>
      </p>
      <p>
        Hoy Almoby es más que nosotros tres. Somos un <strong> equipo </strong>que trabaja todos los días para que
        empresas de distintos
        sectores puedan ordenar su operación, automatizar procesos y crecer sin fricciones. Nos mueve lo mismo desde el
        principio: <span> <strong>crear soluciones digitales útiles, claras y diseñadas desde la realidad de cada
            cliente.</strong></span>
      </p>
      <img src="" alt="">
    </section>
    <section class="seccion faqs">
      <h2>FAQs</h2>
      <div class="contenedorH3p" style="border-top: solid 2px #C93400;" data-aos="fade-up-right">
        <h3>1. ¿ESTO ES SOLO PARA EMPRESAS GRANDES?</h3>
        <p>No. Trabajamos con pymes, emprendimientos familiares y equipos de todos los tamaños.
          Lo importante no es cuán grande sos, sino cuán comprometido estás en querer mejorar.</p>
      </div>
      <div class="contenedorH3p" data-aos="fade-left">
        <h3>2. YA TENGO UN SISTEMA FUNCIONANDO... ¿IGUAL ME SIRVE?</h3>
        <p>Sí. Podemos integrar lo que ya usás o reemplazarlo sin frenar tu operación. No empezás de cero: partimos
          desde tu realidad actual.</p>
      </div>
      <div class="contenedorH3p" data-aos="fade-up-right">
        <h3>3. ¿ES MUY CARO DESARROLLAR ALGO A MEDIDA?</h3>
        <p>Lo que realmente sale caro es seguir perdiendo tiempo y ganancia con procesos mal hechos. Nuestra propuesta
          se adapta a tus necesidades y a tu presupuesto.</p>
      </div>
      <div class="contenedorH3p" data-aos="fade-left">
        <h3>4. ¿CUÁNTO TIEMPO TOMA TENER EL SISTEMA FUNCIONANDO?</h3>
        <p>Depende de la complejidad, pero siempre te damos un cronograma claro desde el día uno. Lo desarrollamos por
          etapas para que veas avances reales mientras trabajamos.</p>
      </div>
      <div class="contenedorH3p" data-aos="fade-right">
        <h3>5. ¿QUÉ PASA DESPUÉS DE QUE ME ENTREGAN EL SISTEMA?</h3>
        <p>Seguimos ahí. No solo hacemos entregas: damos soporte, ajustamos y te acompañamos para que realmente funcione
          en el día a día. Tu operación puede ser más simple, tu equipo más eficiente y tu ganancia más alta. Todo
          empieza con una conversación.</p>
      </div>
    </section>
    <div class="contenedorBoton" style="margin-bottom: 150px;">
      <a href="https://wa.me/5493774516910?text=Hola%20Almoby%2C%20vengo%20desde%20la%20web.%20Quisiera%20hacer%20una%20consulta."
        target="_blank" rel="noopener" aria-label="Escribir por WhatsApp" title="Escribir por WhatsApp">QUIERO AGENDAR
        UNA REUNIÓN</a>
    </div>
    <section class="seccion nuestrosServicios" id="nuestrosServicios">
      <h2>NUESTROS SERVICIOS</h2>
      <h3>PARA POTENCIAR TU MARCA</h3>
      <div class="contenedorServicios">
        <div class="textosServicios">
          <p>PÁGINAS WEB</p>
          <p>APPS MÓVILES</p>
          <p>CATÁLOGOS ONLINE</p>
          <p>SISTEMAS PARA CONSIGNATARIAS</p>
        </div>
        <div class="contenedorImgs">
          <img class="img1" src="@/assets/images/Catálogo 2.png" alt="">
          <img class="img2" src="@/assets/images/notebook mockup.png" alt="">
        </div>
      </div>
      <div class="contenedorServicios contenedorServiciosIzq">
        <div class="textosServicios textosServiciosIzq">
          <p>SISTEMAS A MEDIDA PARA:</p>
          <p>EMPRESAS DE INVERSIÓN</p>
          <p>GESTIÓN RURAL</p>
          <p>TICKETS PARA EVENTOS</p>
        </div>
        <div class="contenedorImgs">
          <img class="img1 img1Izq" src="@/assets/images/carrusel almoby (1) 2.png" alt="">
          <img class="img2 img2Izq" src="@/assets/images/carrusel almoby 2.png" alt="">
        </div>
      </div>
      <div class="contenedorServicios">
        <div class="textosServicios textosServiciosEsp">
          <p>CHATBOTS CON INTELIGENCIA ARTIFICIAL</p>
          <p>PLATAFORMA TWILIO PARA CREACIÓN DE FLUJOS</p>
          <p>MAILS Y DOMINIOS PARA EMPRESAS</p>
          <p><span>Y MUCHO MÁS!</span></p>
        </div>
        <div class="contenedorImgs contenedorImgsEsp">
          <img class="img2 img2Esp" src="@/assets/images/carrusel almoby (2) 2.png" alt="">
        </div>
      </div>
    </section>
    <div class="resultadosReales">
      <h3 class="h3ResReales">¿QUERÉS RESULTADOS REALES? NOSOTROS TAMBIÉN.
        <br>
        POR ESO TRABAJAMOS CON EMPRESAS QUE SE TOMAN EN SERIO SU
        CRECIMIENTO.
      </h3>
      <div class="contenedorEstoEsParaVos">
        <p class="pParaVos">esto es para vos si...</p>
        <ol class="lista">
          <li>Querés escalar tu empresa sin perder control en el camino</li>
          <li>Sentís que el sistema que usás hoy te frena más de lo que te ayuda</li>
          <li>Probaste soluciones genéricas y ninguna se adaptó a tu forma de trabajar</li>
          <li>Te cansaste de resolver todo con planillas, mensajes y memoria</li>
          <li>Valorás el acompañamiento cercano y querés que te entiendan desde el día uno</li>
          <li>Buscás una solución que no solo funcione, sino que haga crecer tus resultados</li>
        </ol>
      </div>
    </div>
    <div class="contenedorCrecer">
      <h3 class="h3CrecerEmpresa">HACÉ CRECER TU EMPRESA COMO SIEMPRE IMAGINASTE, CON UNA SOLUCIÓN DISEÑADA PARA TU
        REALIDAD, NO PARA UNA TEORÍA.
      </h3>
      <h3 class="reunion">AGENDÁ UNA REUNIÓN CON NUESTRO EQUIPO. QUEREMOS CONOCERTE Y PENSAR JUNTOS CÓMO AYUDARTE A
        CRECER.</h3>
    </div>
    <div class="contenedorBoton">
      <a href="https://wa.me/5493774516910?text=Hola%20Almoby%2C%20vengo%20desde%20la%20web.%20Quisiera%20hacer%20una%20consulta."
        target="_blank" rel="noopener" aria-label="Escribir por WhatsApp" title="Escribir por WhatsApp">EMPEZÁ TU CAMBIO
        CON NOSOTROS</a>
    </div>
    <section class="casosDeExito" data-aos="fade-right">
      <img src="../assets/images/casosDeExito1.png" alt="" data-aos="flip-left">
      <img src="../assets/images/casosDeExito2.png" alt="" data-aos="flip-right">
      <img src="../assets/images/casosDeExito3.png" alt="" data-aos="flip-left">
    </section>
  </div>
</template>
<script>
export default {
  name: "inicio",
};
</script>
<style scoped>
.contenedor {
  width: 100%;
}

.seccionInicial {
  position: relative;
  display: flex;
  align-items: start;
  justify-content: space-between;
  padding: 1vw;
  height: 80vh;
  overflow: hidden;
  text-transform: uppercase;
}

.video-container {
  width: 100vw;
  height: 100%;
}

.video-container iframe {
  width: 70vw;
  height: 100%;
  border: 0;
}

.textos {
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 45%;
  padding-top: 10vw;
  padding-left: 12.5vw;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.textos h1 {
  font-size: 5vw;
  text-align: left;
  text-transform: uppercase;
}

.textos p {
  font-size: 1vw;
  text-align: left;
  text-transform: uppercase;
}

.compu {
  width: 42vw;
}

.spanTexto {
  color: #c93400;
  text-transform: uppercase;
}

.seccion {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5vw;
  gap: 2vw;
}

.comoTrabajamos {
  height: 120vh;
  background: #C93400;
  padding: 5vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2vw;
  text-transform: uppercase;
}

.p1,
.p2 {
  font-weight: 800;
  width: 50%;
  font-size: 15px;
  line-height: 25px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #FFFFFF;
  text-transform: uppercase;
}

.p2 {
  color: black;
  text-transform: uppercase;
}

.pTecno {
  width: 53%;
  text-transform: uppercase;
}

.tecnologia {
  min-height: 200vh;
  padding-top: 10vw;
  text-transform: uppercase;
}

.sistAmedida {
  padding-top: 10vw;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.pSist {
  font-weight: 800;
  font-size: 14vw;
  line-height: 100%;
  background: linear-gradient(194.56deg, #FFFFFF 40.48%, rgba(0, 0, 0, 0) 113.59%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  opacity: 0.07;
  margin-bottom: -4.2vw;
}

.pSistLarg {
  position: relative;
  bottom: 9vw;
  width: 70%;
}

.contenedorTextosSist {
  position: relataive;
}

.contenedorTextosSist:hover {
  animation: swing 1s;
}

.checklist {
  display: flex;
  flex-direction: column;
  align-items: start;
  font-weight: 500;
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 1px;
  gap: 20px;
  margin-top: 8vw;
}

.check {
  color: gray;
  margin-right: 6px;
  font-size: 24px;
  flex-shrink: 0;
}

.contenedorMarron {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  padding: 2vw;
  background: rgba(62, 64, 67, 0.18);
  gap: 30px;
  margin-top: 8vw;
  margin-bottom: 8vw;
}

.contenedorMarron p {
  font-weight: 500;
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 1px;
}

.cuadriculaNaranja {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1vw;
}

.rectanguloNaranja {
  width: 530px;
  height: 150px;
  background: #B93205;
  display: flex;
  flex-direction: column;
  padding: 2vw;
}

.rnP1,
.rnP2 {
  font-weight: 500;
  font-size: 15px;
  line-height: 120%;
  color: #FFFFFF;
  text-align: left;
}

.rnP2 {
  font-weight: 600;
  border-bottom: solid 2px #FFFFFF;
  width: max-content;
  line-height: 150%;
  margin-bottom: 0.8vw;
}

.rnP3 {
  font-family: 'WorkSans';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 120%;
  color: #FFFFFF;
  text-transform: lowercase;
  text-transform: initial;
  text-align: left;
  letter-spacing: 0px;
}

.sobreAlmoby h2,
.faqs h2,
.nuestrosServicios h2,
.nuestrosServicios h3 {
  font-weight: 800;
  font-size: 50px;
  line-height: 100%;
  text-align: center;
  background: linear-gradient(180deg, #C93400 -151.36%, #541600 335.62%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.nuestrosServicios {
  padding: 0 !important;
  overflow: hidden;
}

.nuestrosServicios h3 {
  font-size: 30px;
  font-weight: 500;
  margin-bottom: 150px;
}

.nuestrosServicios h2 {
  margin-bottom: -1.5%;
}

.sobreAlmoby p {
  font-family: 'WorkSans';
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;
  text-align: center;
  color: #FFFFFF;
  width: 85%;
}

.sobreAlmoby span {
  background: linear-gradient(180deg, #C93400 -151.36%, #541600 335.62%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.contenedorH3p {
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 15px;
  border-bottom: solid 2px #C93400;
  padding-top: 35px;
  padding-bottom: 35px;
}

.contenedorH3p p {
  font-family: 'WorkSans';
  font-weight: 400;
  font-size: 18px;
  line-height: 120%;
  color: #FFFFFF;
  text-align: left;
  letter-spacing: 0.2px;
}

.contenedorBoton {
  display: flex;
  justify-content: center;

}

.contenedorBoton a {
  border: none;
  background: #C93400;
  border-radius: 18px;
  padding: 10px 25px 10px 25px;
  font-weight: 800;
  font-size: 18px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.5px;
  color: #FFFFFF;
  transition: background-color 0.5s ease;
  cursor: pointer;
}


.contenedorBoton a:hover {
  background: linear-gradient(90deg, #e1853a 0%, #C93400 100%);
}


.resultadosReales {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.h3ResReales,
.h3CrecerEmpresa,
.reunion {
  margin-top: 150px;
  font-size: 18px;
  margin-bottom: 80px;
}

.contenedorEstoEsParaVos {
  text-align: left;
  text-transform: uppercase;
  background: rgba(62, 64, 67, 0.3);
  width: 70%;
  padding: 80px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.pParaVos {
  color: #C93400;
}

.lista {
  display: flex;
  flex-direction: column;
  gap: 15px;
  font-weight: 500;
}

.contenedorCrecer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.h3CrecerEmpresa {
  margin-bottom: 0;
  width: 70%;
}

.reunion {
  color: #C93400;
  width: 70%;
  border: 1px solid #C93400;
  border-radius: 20px;
  padding: 10px;
  margin-top: 40px;
}

.contenedorServicios {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 150px;
}

.contenedorServiciosIzq {
  flex-direction: row-reverse;
}

.textosServicios {
  text-align: left;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-left: 100px;
  width: 50%;
}

.textosServicios span {
  color: #C93400;
}

.textosServiciosIzq {
  padding-left: 0px;
  padding-right: 100px;
  text-align: right;
}

.textosServicios p {
  font-size: 20px;
}


.contenedorImgs {
  position: relative;
}

.contenedorImgsEsp {
  overflow: visible;
}

.img1 {
  width: 18%;
  border-radius: 8px;
  position: absolute;
  right: 65%;
  top: 40%;
  z-index: 2;
  -webkit-mask-image: linear-gradient(to bottom, black 70%, transparent 100%);
  mask-image: linear-gradient(to bottom, black 70%, transparent 100%);
}

.img1Izq {
  right: 0%;
  top: 30%;
  left: 60%;
}

.img2 {
  width: 90%;
  position: relative;
  right: -100px;
  z-index: 1;
  filter: drop-shadow(0 0 60px rgba(0, 0, 0, 0.7));
  -webkit-mask-image: linear-gradient(to right, black 0%, transparent 100%);
  mask-image: linear-gradient(to right, black 0%, transparent 100%);
}

.img2Izq {
  width: 90%;
  left: -15%;
  -webkit-mask-image: linear-gradient(to left, black 0%, transparent 100%);
  mask-image: linear-gradient(to left, black 0%, transparent 100%);
}

.img2Esp {
  width: 400px;
  right: 150px;
  -webkit-mask-image: linear-gradient(to bottom, black 70%, transparent 100%);
  mask-image: linear-gradient(to bottom, black 70%, transparent 100%);
}

.casosDeExito {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 80px;
  margin-top: 100px;
}

.casosDeExito img {
  width: 90%;
  border: 1px solid #685E54;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;

}

@media screen and (max-width: 1000px) {

  .seccionInicial {
    height: auto;
  }

  .p1,
  .p2 {
    width: 100%;
  }

  .img2Esp {
    right: 20px;
  }

  .contenedorServicios {
    flex-direction: column-reverse;
    margin-bottom: 50px;
  }

  .textosServicios {
    text-align: center;
    margin-top: 80px;
    padding-left: 0px;
    padding-right: 0px;
  }

  .img2 {
    right: 0%;
    left: 0%;
  }


  .h3ResReales {
    padding-left: 3vw;
    padding-right: 3vw;
    margin-top: 50px;
  }

}

@media screen and (max-width: 600px) {
  .rectanguloNaranja {
    width: 100%;
  }

  .rnP1,
  .rnP2 {
    width: 100%;
  }

  .cuadriculaNaranja {
    gap: 3vw;
  }

  .contenedorBoton {
    padding: 5vw;
  }

  .contenedorBoton button {
    padding: 10px 10px 10px 15px;
    font-size: 13px;
  }

  .reunion {
    width: 90%;
  }

  .contenedorEstoEsParaVos {
    width: 90%;
  }

  .img2Esp {
    width: 50%;
  }

  .nuestrosServicios h2 {
    font-size: 40px;
  }

  .nuestrosServicios h3 {
    margin-bottom: 100px;
    font-size: 20px;
    padding: 2vw;
  }


  .textosServicios {
    width: 90%;
  }

  .h3CrecerEmpresa {
    margin-top: 50px;
    width: 90%;
  }

  .textos {
    padding-left: 8vw
  }

  .textos h1 {
    font-size: 10vw;
  }

  .textos p {
    font-size: 3vw;
  }

  .compu {
    width: 70vw;
  }

  .checklist {
    font-size: 15px;
    width: 90%;
    line-height: 150%;
  }

  .sistAmedida {
    padding-top: 10vw;
  }

  .pSistLarg {
    bottom: 12vw;
    width: 90%;
    font-size: 12px;
    font-weight: 500;
  }

  .contenedorH3p {
    text-align: left;
  }

  .contenedorMarron p {
    width: 90% !important;
  }
}
</style>